import mvtAutocomplete from '@/common/components/mvtautocomplete/mvt-autocomplete.vue';
import mvtPicture from '@/common/components/mvtpicture/mvt-picture.vue';
import sitemapBreadcrumb from '@/sitemap/components/sitemapbreadcrumb/sitemap-breadcrumb.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'sitemapWelcome',
    props: {
        sitemap: Object,
        categorySelected: String,
        alt: {
            default: 'Welcome-Sitemap Movoto'
        }
    },
    components: {
        mvtPicture,
        sitemapBreadcrumb,
        mvtAutocomplete
    },
    watch:{
        searchInfo(newVal){
            if(newVal){
                this.$eventBus.$emit('eventbus-search', {
                    text: newVal.text,
                    geo: newVal.geo,
                    isGoogleGeo: newVal.isGoogleGeo,
                    isMlsNumber: newVal.isMlsNumber
                });
            }
         }
    },
    data: function() {
        return {
            searchInfo: {
                text: '',
                geo: null,
                extraPath: ''
            }
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        getHeroImage() {
            return this.sitemap.bannerUrl;
        },
        getHeroImgWebp() {
            return this.sitemap.bannerUrlWebp;
        },
        getTitle() {
            return this.sitemap.pageTitle;
        },
        getBreadcrumbData() {
            return this.sitemap.breadCrumb;
        },
        getLangBasedTitle() {
            if(this.sitemap.pageType !== 'vsitemap_state' && this.sitemap.pageType !== 'vsitemap_stateletter'){
                return null;
            }
            let title = '';
            if (this.sitemap.language && this.sitemap.stateInfo) {
                if (this.sitemap.letter) {
                    title = `${this.molang('common.sitemap.h1.letter', { state: this.sitemap.stateInfo.displayName, letter: this.sitemap.letter.toUpperCase() })}`
                } else {
                    title = `${this.molang('common.sitemap.h1.state', { state: this.sitemap.stateInfo.displayName })}`;
                }
            }
            return title;
        },
        getAutoCompleteOpt() {
            return {
                filterType: this.sitemap.isAgent? 'Agents':'Sitemap',
                includeAgentProfiles: true,
                hideDefaultSuggest: false,
                showGroupedSuggest: true,
            };
        }
    }
};